import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import Tooltip from '@components/interface/Tooltip';
import { IconPointFilled } from '@tabler/icons-react';

type NavBarButtonProps = {
  id: string;
  to: string;
  icon: string;
  isExpanded: boolean;
  label: string;
  notIncludedOnCurrentPlan?: boolean;
  tablerIcon?: ReactNode;
};

const NavBarButton = ({
  to,
  id,
  icon,
  isExpanded,
  label,
  notIncludedOnCurrentPlan = false,
  tablerIcon,
}: NavBarButtonProps) => {
  return (
    <Tooltip label={label} enabled={!isExpanded}>
      <NavLink
        to={notIncludedOnCurrentPlan ? `suscripcion/${to}` : to}
        className={({ isActive }) =>
          `relative flex items-center px-2 py-2 text-base rounded-md hover:bg-color-gray_light transition-colors ${
            isActive
              ? 'text-color-primary bg-color-gray_light border-r-4 border-color-secondary'
              : 'text-color-gray_ultra_dark'
          }`
        }
        id={id}
      >
        {tablerIcon ? (
          <div className="w-5 flex-shrink-0">{tablerIcon}</div>
        ) : (
          <img src={icon} alt="navegacion" className="w-5 flex-shrink-0" />
        )}
        <div className={`overflow-hidden transition-all ${isExpanded ? 'ml-2 w-full opacity-100' : 'w-0 opacity-0'}`}>
          <span className="whitespace-nowrap">{label}</span>
        </div>
        {notIncludedOnCurrentPlan && (
          <div className="ml-auto">
            <IconPointFilled className="text-color-secondary" width={14} />
          </div>
        )}
      </NavLink>
    </Tooltip>
  );
};

export default NavBarButton;
